import { atomWithReset } from 'jotai/utils';

export type ViolationType = 'tab_switch' | 'fullscreen_exit';

export const mockTestViolationCountAtom = atomWithReset<number>(0);
export const isMockTestWarningOpenAtom = atomWithReset<boolean>(false);
export const ieltsTestModeAtom = atomWithReset<'practice' | 'simulation' | null>(null);
export const isMockTestWarningSuppressedAtom = atomWithReset<boolean>(false);
export const mockTestLastViolationTypeAtom = atomWithReset<ViolationType>('tab_switch');
